module.exports = __webpack_public_path__ + "static/media/slider-image-01.0ee61d2d.jpg";